import { __assign, __rest } from "tslib";
import React from 'react';
import InternalCheckbox from './internal';
var Checkbox = React.forwardRef(function (_a, ref) {
    var props = __rest(_a, []);
    return (React.createElement(InternalCheckbox, __assign({}, props, { ref: ref })));
});
export default Checkbox;
